"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByDirection = void 0;
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection["ASCENDING"] = "ascending";
    OrderByDirection["DESCENDING"] = "descending";
})(OrderByDirection = exports.OrderByDirection || (exports.OrderByDirection = {}));
